import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import { API } from 'api';
import { zoneActions } from './zone.slice';

export const useZoneActions = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();

  const getZones = useCallback(async () => {
    const resp = await API.zone.getZone();
    const urlParams = qs.parse(search, { ignoreQueryPrefix: true });
    const selectedZone = resp.data.find(({ id }) => id === Number(urlParams?.zone));
    const zonesData = {
      zones: resp.data,
      selected: selectedZone?.id ?? resp.data[0]?.id
    };
    dispatch(zoneActions.setZone(zonesData));
  }, [dispatch, search]);

  const setSelectedZone = useCallback(
    id => {
      dispatch(zoneActions.setSelectedZone(id));
    },
    [dispatch]
  );

  return {
    getZones,
    setSelectedZone
  };
};
